import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Theme,
  useMediaQuery,
} from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import noop from '../../utility/noop';
import { useId } from '../../hooks';
import { studioModalStyles } from './styles';

type Props = {
  open: boolean;
  title: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  text?: string;
};
export default function StudioModal({
  open,
  title,
  onClose = noop,
  text,
  children,
}: Props) {
  const theme = useTheme<Theme>();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const id = useId();
  const classes = studioModalStyles();

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby={id}
      style={{ zIndex: 2147483102 }}
      PaperProps={{ className: classes.root }}
    >
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        {text && <DialogContentText className={classes.description}>{text}</DialogContentText>}
      </DialogContent>
      {children}
    </Dialog>
  );
}
